<template>
	<div>
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="70%">
			<el-form ref="show" :model="dataSource" label-width="150px">
				<el-tabs v-model="activeName" type="card" style="max-height:580px;">
					<el-tab-pane label="公司信息" name="baseTab">
						<el-descriptions class="margin-top" title="" :column="2" size="medium" :labelStyle="label_style" :contentStyle="content_style" border>
							<el-descriptions-item>
								<template slot="label">
									企业名称
								</template>
								<a :href= "'https://aiqicha.baidu.com/s?q=' + dataSource.name" target="_blank" v-if="dataSource.resourcesLink==undefined">{{dataSource.name}}</a>
								<a :href= "dataSource.resourcesLink" target="_blank" v-if="dataSource.resourcesLink">{{dataSource.name}}</a>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									统一社会信用代码
								</template>
								{{dataSource.taxNo}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									法定代表人
								</template>
								{{dataSource.legalPerson}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									经营状态
								</template>
								{{dataSource.companyStatus}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									成立日期
								</template>
								{{dataSource.establishDate}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									行政区划
								</template>
								{{dataSource.areaRemark}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									注册资本
								</template>
								{{dataSource.registeredCapital}}万{{dataSource.capitalType=="人民币"?"":"(" + dataSource.capitalType + ")"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									实缴资本
								</template>
								{{dataSource.realCapital}}万{{dataSource.capitalType=="人民币"?"":"(" + dataSource.capitalType + ")"}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									企业类型
								</template>
								{{dataSource.companyType}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									所属行业
								</template>
								{{dataSource.industry}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									参保人数
								</template>
								{{dataSource.socialSecurityNum}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									注册地址
								</template>
								{{dataSource.address}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									来源
								</template>
								{{sourceFormat(null, null, dataSource.source)}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									状态
								</template>
								{{statusFormat(null, null, dataSource.status)}}
							</el-descriptions-item>
							<el-descriptions-item span="2">
								<template slot="label">
									经营范围
								</template>
								{{dataSource.businessScope}}
							</el-descriptions-item>
						</el-descriptions>
					</el-tab-pane>
					<el-tab-pane label="成员组成" name="memberTab" v-if="shareholders.length > 0 || keyMembers.length > 0">
						<el-row>
							<el-col :span="11" style="padding-left:5px;padding-right:15px;">
								<el-divider><i class="el-icon-s-custom"></i>股东</el-divider>
								<el-table
									:data="shareholders"
									border
									class="table"
									ref="multipleTable"
									header-cell-class-name="table-header"
									:cell-style="{padding:4+'px'}"
									size="medium"
									stripe
								>
									<el-table-column type="index" width="50"></el-table-column>
									<el-table-column prop="name" label="股东名称"></el-table-column>
									<el-table-column prop="contributionRatio" label="持股比例"></el-table-column>
									<el-table-column prop="position" label="认缴出资额"></el-table-column>
									<el-table-column prop="subscriptionDate" label="认缴出资日期"></el-table-column>
								</el-table>
							</el-col>
							<el-col :span="13" style="padding-left:15px;padding-right:5px;">
								<el-divider><i class="el-icon-user-solid"></i>主要人员</el-divider>
								<el-table
									:data="keyMembers"
									border
									class="table"
									ref="multipleTable"
									header-cell-class-name="table-header"
									:cell-style="{padding:4+'px'}"
									size="medium"
									stripe
								>
									<el-table-column type="index" width="50"></el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="position" label="职务"></el-table-column>
									<el-table-column prop="contributionRatio" label="持股比例"></el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="联系方式" name="contactTab">
						<div style="max-height: 500px; overflow: auto; ">
							<el-descriptions class="margin-top" title="" :column="2" size="medium" :labelStyle="label_style" :contentStyle="content_style" border>
								<el-descriptions-item>
									<template slot="label">
										网站
									</template>
									<a :href= "(dataSource.website.indexOf('http')==-1?'http://':'') + dataSource.website" target="_blank" v-if="dataSource.website">{{dataSource.website}}</a>
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										联系地址
									</template>
									{{dataSource.collectAddress?dataSource.collectAddress:(dataSource.latestAddress?dataSource.latestAddress:dataSource.address)}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										关键字
									</template>
									{{dataSource.careKeyValue}}
								</el-descriptions-item>
								<!--
								<el-descriptions-item>
									<template slot="label">
										电话
									</template>
									{{dataSource.tel}}
								</el-descriptions-item>
								<el-descriptions-item span="2">
									<template slot="label">
										更多电话
									</template>
									{{dataSource.otherTel}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										邮箱
									</template>
									{{dataSource.mail}}
								</el-descriptions-item>
								<el-descriptions-item span="2">
									<template slot="label">
										更多邮箱
									</template>
									{{dataSource.otherMail}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										采集手机
									</template>
									{{dataSource.collectMobile}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										采集电话
									</template>
									{{dataSource.collectTel}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										采集邮箱
									</template>
									{{dataSource.collectMail}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										关注电话
									</template>
									<font color="red">{{dataSource.careTel}}</font>
								</el-descriptions-item>
								-->
							</el-descriptions>
							<el-divider v-if="mobiles.length > 0" content-position="left"><i class="el-icon-mobile-phone"></i>手机</el-divider>
							<el-descriptions v-if="mobiles.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in mobiles">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											来&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.platforms">{{item.platforms}}</span>
										</div>
										<div class="card-content">
											状&nbsp;&nbsp;&nbsp;&nbsp;态：<span :ref="item.id">{{contactStatusFormatter("mobile", item.status)}}</span>
											&nbsp;&nbsp;
											<el-dropdown @command="handleCommand">
												<el-button type="text" class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item :command="composeValue(1, 'mobile', item.id)">已发送请求</el-dropdown-item>
													<el-dropdown-item :command="composeValue(2, 'mobile', item.id)">成为好友</el-dropdown-item>
													<el-dropdown-item :command="composeValue(3, 'mobile', item.id)">无效</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
							<el-divider v-if="tels.length > 0" content-position="left"><i class="el-icon-phone-outline"></i>固定电话</el-divider>
							<el-descriptions v-if="tels.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in tels">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											来&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.platforms">{{item.platforms}}</span>
										</div>
										<div class="card-content">
											状&nbsp;&nbsp;&nbsp;&nbsp;态：<span :ref="item.id">{{contactStatusFormatter("tel", item.status)}}</span>
											&nbsp;&nbsp;
											<el-dropdown @command="handleCommand">
												<el-button type="text" class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item :command="composeValue(1, 'tel', item.id)">未接通</el-dropdown-item>
													<el-dropdown-item :command="composeValue(2, 'tel', item.id)">已经联系</el-dropdown-item>
													<el-dropdown-item :command="composeValue(3, 'tel', item.id)">无效</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
							<el-divider v-if="mails.length > 0" content-position="left"><i class="el-icon-eleme"></i>邮件地址</el-divider>
							<el-descriptions v-if="mails.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in mails">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											来&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.platforms">{{item.platforms}}</span>
										</div>
										<div class="card-content">
											状&nbsp;&nbsp;&nbsp;&nbsp;态：<span :ref="item.id">{{contactStatusFormatter("mail", item.status)}}</span>
											&nbsp;&nbsp;
											<el-dropdown @command="handleCommand">
												<el-button type="text" class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item :command="composeValue(1, 'mail', item.id)">已发送邮件</el-dropdown-item>
													<el-dropdown-item :command="composeValue(2, 'mail', item.id)">已阅读</el-dropdown-item>
													<el-dropdown-item :command="composeValue(3, 'mail', item.id)">无效</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
							<el-divider v-if="qqs.length > 0" content-position="left"><i class="el-icon-chat-square"></i>QQ号码</el-divider>
							<el-descriptions v-if="qqs.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in qqs">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											来&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.platforms">{{item.platforms}}</span>
										</div>
										<div class="card-content">
											状&nbsp;&nbsp;&nbsp;&nbsp;态：<span :ref="item.id">{{contactStatusFormatter("qq", item.status)}}</span>
											&nbsp;&nbsp;
											<el-dropdown @command="handleCommand">
												<el-button type="text" class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item :command="composeValue(1, 'qq', item.id)">已发送请求</el-dropdown-item>
													<el-dropdown-item :command="composeValue(2, 'qq', item.id)">成为好友</el-dropdown-item>
													<el-dropdown-item :command="composeValue(3, 'qq', item.id)">无效</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
							<el-divider v-if="wechats.length > 0" content-position="left"><i class="el-icon-chat-round"></i>微信号码</el-divider>
							<el-descriptions v-if="wechats.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in wechats">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											状&nbsp;&nbsp;&nbsp;&nbsp;态：<span :ref="item.id">{{contactStatusFormatter("wechat", item.status)}}</span>
											&nbsp;&nbsp;
											<el-dropdown @command="handleCommand">
												<el-button type="text" class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item :command="composeValue(1, 'wechat', item.id)">已发送请求</el-dropdown-item>
													<el-dropdown-item :command="composeValue(2, 'wechat', item.id)">成为好友</el-dropdown-item>
													<el-dropdown-item :command="composeValue(3, 'wechat', item.id)">无效</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
							<el-divider v-if="others.length > 0" content-position="left"><i class="el-icon-message"></i>其他联系方式</el-divider>
							<el-descriptions v-if="others.length > 0" class="margin-top" :colon = false :column="5" size="medium" direction="vertical">
								<el-descriptions-item v-for="item in others">
									<el-card class="card" shadow="hover" style="width:200px;margin-left:10px;margin-right:10px;">
										<div slot="header" class="clearfix">
											<span>{{item.contactInfo}}</span>
										</div>
										<div class="card-content">
											联系人：<span :title="item.name">{{item.name}}</span>
										</div>
										<div class="card-content">
											职&nbsp;&nbsp;&nbsp;&nbsp;务：<span :title="item.position">{{item.position}}</span>
										</div>
										<div class="card-content">
											来&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.platforms">{{item.platforms}}</span>
										</div>
									</el-card>
								</el-descriptions-item>
							</el-descriptions>
						</div>
					</el-tab-pane>
					<el-tab-pane label="分析结果" name="resultTab">
						<div style="max-height: 500px; overflow: auto; ">
							<el-descriptions class="margin-top" title="" :column="1" size="medium" :labelStyle="label_style" :contentStyle="content_style" border>
								<el-descriptions-item>
									<template slot="label">
										资源类型
									</template>
									{{customerTypeFormat(null, null, dataSource.resourcesType)}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										产品采集来源
									</template>
									<a :href= "(dataSource.productPage.indexOf('http')==-1?'http://':'') + dataSource.productPage" target="_blank" v-if="dataSource.productPage">{{platformFormat(null, null, dataSource.collectFrom)}}</a>
									<a v-if="dataSource.productPage==undefined">{{platformFormat(null, null, dataSource.collectFrom)}}</a>
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										评分
									</template>
									{{dataSource.score}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										评分项
									</template>
									<p v-for="(item,i) in strToList(dataSource.scoreItem, '，')" :key="i">
										{{item}}
									</p>
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										定位
									</template>
									{{dataSource.location}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										生产/供应产品
									</template>
									{{dataSource.mainBusiness}}
								</el-descriptions-item>
								<el-descriptions-item>
									<template slot="label">
										参考链接
									</template>
									<p v-for="(item,i) in strToList(dataSource.referenceLinking, ',')" :key="i">
										<a :href= "item" target="_blank">{{item}}</a><br/>
									</p>	
								</el-descriptions-item>
							</el-descriptions>
						</div>
					</el-tab-pane>
					<el-tab-pane label="关联元器件" name="productTab" v-if = "dataSource.realProducts||dataSource.predictionProducts">
						<el-descriptions class="margin-top" title="" :column="1" size="medium" :labelStyle="label_style" :contentStyle="content_style" border>
							<el-descriptions-item>
								<template slot="label">
									预测使用元器件
								</template>
								<p v-for="(item,i) in dataSource.predictionProducts" :key="i">
									<el-tag :type= 'warning' style="float:left; margin:5px;">{{item}}</el-tag>
								</p>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									实际用到元器件
								</template>
								<p v-for="(item,i) in dataSource.realProducts" :key="i">
									<el-tag :type= 'success' style="float:left; margin:5px;">{{item}}</el-tag>
								</p>
							</el-descriptions-item>
						</el-descriptions>
					</el-tab-pane>
				</el-tabs>
			</el-form>
        </el-dialog>
	</div>
</template>

<script>
import {updateContactStatus} from '../../api/index';
export default {
    name: 'PotentialResourcesView',
    data() {
        return {
			label_style: {
				'width': "150px",
				'word-break': 'keep-all'
			},
			content_style: {
				'min-width': '200px',
				'word-break': 'break-all' //过长时自动换行
			},
			dataSource:[],
			showVisible:false,
			activeName:"baseTab",
			platformKV:[],
			shareholders:[],
			keyMembers:[],
			mobiles:[],
			tels:[],
			qqs:[],
			mails:[],
			wechats:[],
			others:[],
			statusKV:{"mobile":{"0":"未联系","1":"已发送请求","2":"已成为好友","3":"无效"},
			"tel":{"0":"未联系","1":"未接通","2":"已联系","3":"无效"},
			"qq":{"0":"未联系","1":"已发送请求","2":"已成为好友","3":"无效"},
			"mail":{"0":"未联系","1":"已发送邮件","2":"已成阅读","3":"无效"},
			"wechat":{"0":"未联系","1":"已发送请求","2":"已成为好友","3":"无效"}},
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
        };
    },
    methods: {
		setDatasource(data, platformKV, isRefresh) {
			this.platformKV = platformKV;
			this.dataSource = data;
			if (!(data["careKey"] == undefined || data["careKey"] == "")) {
				let careKeyNode = JSON.parse(data["careKey"]);
				let careKeyValue = ""
				for (let key in careKeyNode) {
					careKeyValue = (careKeyValue == "" ? "" : careKeyValue+" , ") + key + "【" + careKeyNode[key] + "】";
				}
				this.dataSource["careKeyValue"] = careKeyValue;
			}
			this.shareholders = data["shareholders"];
			this.keyMembers = data["keyMembers"];
			this.mobiles = data["mobiles"];
			this.tels = data["tels"];
			this.qqs = data["qqs"];
			this.mails = data["mails"];
			this.wechats = data["wechats"];
			this.others = data["others"];
			if (!isRefresh) {
				this.showVisible = true;
				this.activeName = "baseTab";
			}
		},
		handleCommand(command) {
			updateContactStatus(command).then(res => {
				if (res.code == 0 ) {
					this.refreshData(command);
					//this.$refs[command["id"]][0].innerText = this.statusKV[command["type"]][command["status"]];
				} else {
					this.$message.error("状态更新失败！" + res.message);
				}
			})
		},
		refreshData(command) {
			let obj = this.dataSource[command["type"] + "s"];
			for (var i = 0; i < obj.length; i++) {
				if (obj[i]["id"] == command["id"]) {
					obj[i]["status"] = command["status"];
					this.setDatasource(this.dataSource, this.platformKV, true);
					break;
				}
			}
		},
		composeValue(commandStatus, type, id) {
			let param = {};
			param["status"] = commandStatus;
			param["type"] = type;
			param["id"] = id;
			return param;
		},
		contactStatusFormatter(type, status) {
			return this.statusKV[type][status];
		},
		sourceFormat(row, column, cellValue) {
			let sourceKV = {"0":"手动录入", "1" :"爱企查导入"};
			if (typeof(cellValue) != undefined) {
				return sourceKV[cellValue];
			}
			return cellValue;
		},
		statusFormat(row, column, cellValue) {
			let statusKV = {"0":"建档", "1" :"数据分析中", "2":"数据分析完成","3" :"已发信息", "4":"已成好友", "5":"已沟通/拜访", "6":"已合作", "7":"无效"};
			if (typeof(cellValue) != undefined) {
				return statusKV[cellValue];
			}
			return cellValue;
		},
		platformFormat(row, column, cellValue) {
			if (cellValue == -1) {
				return "经营范围";
			} else if (cellValue == -2) {
				return "企业关键字";
			} else if (cellValue == 0) {
				return "企业官网";
			} else {
				let index = this.platformKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
				});
				if (index === -1) return cellValue;
				return this.platformKV[index].value;
			}
		},
		//评分项转列表
		strToList(val, splitStr) {
			let list = [];
			if (val == undefined) {
				return list;
			}
			let array = val.split(splitStr);
			for(var i = 0; i < array.length; i++) {
				list.push(array[i]);
			}
			return list;
		},
		//客户类型格式化
		customerTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.customerTypeKV.length; i++) {
				if (this.customerTypeKV[i].key === cellValue){
					return this.customerTypeKV[i].value;
				}
			}
			return " - ";
		}
    }
};
</script>
<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
</style>
<style scoped>
  /deep/ .el-card__header {
    padding: 12px 12px;
    font-size: 14px;
	color:#E6A23C;
	background-color:#F2F6FC;
  }

  /deep/ .el-card__body {
    padding-left:15px;
	padding-right:15px;
	padding-bottom:20px;
	
  }
  
  .card-content {
	padding-top:10px;
	padding-bottom:5px;
	border-bottom:#E4E7ED solid 1px;
	white-space: nowrap;  
    overflow: hidden;  
    text-overflow: ellipsis;  
    max-width: 200px;
  }
  
  .card-content span{
	color:#909399;
  }
</style>